import uniqueId from 'lodash/uniqueId';

import type {
    EmailSequenceTemplateTemplate,
    GetEmailSequenceTemplate_emailSequenceTemplate,
    GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages,
} from 'nutshell-graphql-types';

import {createNormalizedSequenceTemplate} from '../create-empty-sequence-template';

export function copyEmailSequenceTemplateForCurrentUser(
    sourceEmailSequenceTemplate: GetEmailSequenceTemplate_emailSequenceTemplate
): EmailSequenceTemplateTemplate {
    const newUserEmailSequenceTemplate = createNormalizedSequenceTemplate();

    // Copy over data as needed...
    newUserEmailSequenceTemplate.name = sourceEmailSequenceTemplate.name;
    newUserEmailSequenceTemplate.parent = {
        __typename: 'EmailSequenceTemplate',
        // If the copied email sequence has a parent, use that id. Otherwise
        // the copied email sequence is the parent
        id: sourceEmailSequenceTemplate.parent
            ? sourceEmailSequenceTemplate.parent.id
            : sourceEmailSequenceTemplate.id,
        creatorUser: {
            __typename: 'User',
            id: sourceEmailSequenceTemplate.creatorUser.id,
            name: sourceEmailSequenceTemplate.creatorUser.name,
            isEnabled: sourceEmailSequenceTemplate.creatorUser.isEnabled,
        },
    };

    // Copy the data to a new array for the user's email sequence template
    const newUserEmailTemplates = sourceEmailSequenceTemplate.emailSequenceTemplateMessages.map(
        (
            emailTemplateMessage: GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages
        ) => {
            return {
                ...emailTemplateMessage,
                id: uniqueId(),
                sendDelay: {
                    // Copy this, for a new reference
                    ...emailTemplateMessage.sendDelay,
                },
                emailTemplate: {
                    // Copy this, for a new reference
                    ...emailTemplateMessage.emailTemplate,
                    // Its never been sent before
                    sentCount: 0,
                    openedCount: 0,
                    clickCount: 0,
                },
            };
        }
    );

    return {
        ...newUserEmailSequenceTemplate,
        // @ts-expect-error
        emailSequenceTemplateMessages: newUserEmailTemplates,
    };
}
